import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import orderService from "../services/order.service";
import { toast } from "react-toastify";

function OrderScreen() {
  const location = useLocation();
  const { order_item_id } = location?.state || {};
  const { t } = useTranslation();
  const [order, setOrder] = useState(null);

  const cancelableStatus = ["Shipped", "Out for delivery"];
  const isCancelable = order && !cancelableStatus.includes(order?.status?.name);

  useEffect(() => {
    if (order_item_id && !order) {
      orderService
        .getOrderDataById(order_item_id)
        .then((res) => {
          setOrder(res.data);
        })
        .catch((error) => {
          console.error("Order details error:", error);
        });
    }
  }, [order_item_id]);

  const cancelOrder = (order_item_id) => {
    if (!order_item_id) return;

    if (window.confirm("You want to cancel the order?")) {
      orderService
        .cancelOrderById(order_item_id)
        .then(() => {
          setOrder((prev) => ({
            ...prev,
            status: { ...prev.status, name: "Cancelled" },
          }));

          toast.success("🚫 Order cancelled successfully!", {
            position: "top-right",
            autoClose: 3000,
          });
        })
        .catch(() => {
          toast.error("❌ Failed to cancel order.");
        });
    }
  };

  const SummaryText = ({ title, value, style = {} }) => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        margin: "6px 0",
        ...style,
      }}
    >
      <span style={{ fontWeight: 500 }}>{title}</span>
      <span>{value}</span>
    </div>
  );

  const imageURL =
    order?.product?.media?.[0]?.image?.image?.replace(
      /\/media\/(marketplace\/)?/,
      ""
    ) || "https://via.placeholder.com/200";

  return (
    <div
      style={{
        padding: 20,
        maxWidth: 1000,
        margin: "10px auto",
        background: "#fff",
        borderRadius: 10,
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        border: "1px solid #eee",
      }}
    >
      {order ? (
        <>
          <div style={{ marginBottom: 20 }}>
            <h5>Order ID: #{order.order?.order_id}</h5>
            <h4>Status: {order.status?.name}</h4>
            {order.order_item_transection?.map((item, index) => (
              <SummaryText
                key={index}
                title={item.status?.name}
                value={new Date(item.created_at).toLocaleString("en-GB", {
                  dateStyle: "short",
                })}
              />
            ))}
          </div>

          <hr />

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 20,
              marginBottom: 20,
              alignItems: "flex-start",
            }}
          >
            <img
              alt="Product"
              src={imageURL}
              style={{
                width: "200px",
                height: "200px",
                objectFit: "contain",
                borderRadius: 10,
                border: "1px solid #eee",
                backgroundColor: "#f9f9f9",
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://via.placeholder.com/200";
              }}
            />

            <div style={{ flex: 1, minWidth: 250 }}>
              <h5>{order.product?.product?.name}</h5>
              <p>{order.product?.product?.brand?.name}</p>
              <SummaryText
                title="Seller"
                value={order.product?.product?.seller?.name}
              />
              <SummaryText
                title="Product Amount"
                value={`₹${order.product_amount}`}
              />
              <SummaryText title="Quantity" value={order.quantity} />
              <SummaryText
                title="Paid Amount"
                value={`₹${order.order?.total_amount}`}
                style={{ fontWeight: "bold", color: "green" }}
              />
              <p style={{ fontSize: 14, color: "#666" }}>
                Ordered On:{" "}
                {new Date(order.created_at).toLocaleString("en-GB", {
                  dateStyle: "short",
                })}
              </p>
            </div>
          </div>

          <hr />

          <div style={{ marginBottom: 20 }}>
            <h4>
              <strong>Shipping Address</strong>
            </h4>
            <div style={{ lineHeight: 1.6 }}>
              <p>
                {[
                  order.order?.shipping_detail?.shipping_address?.address,
                  order.order?.shipping_detail?.shipping_address?.apartment,
                  order.order?.shipping_detail?.shipping_address?.city,
                  order.order?.shipping_detail?.shipping_address?.state,
                  order.order?.shipping_detail?.shipping_address?.pincode,
                  order.order?.shipping_detail?.shipping_address?.country,
                ]
                  .filter(Boolean)
                  .join(", ")}
              </p>
              <p>
                Mobile: {order.order?.shipping_detail?.shipping_address?.mobile}
              </p>
            </div>
          </div>

          <div>
            <Button
              disabled={!isCancelable}
              variant="danger"
              onClick={() => cancelOrder(order_item_id)}
              style={{
                cursor: isCancelable ? "pointer" : "not-allowed",
                opacity: isCancelable ? 1 : 0.5,
              }}
            >
              Cancel
            </Button>
          </div>
        </>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default OrderScreen;
